<template>
  <div style="border: 1px solid #ccc">
    <Toolbar
      style="border-bottom: 1px solid #ccc"
      :editor="editor"
      :defaultConfig="toolbarConfig"
      :mode="mode"
    />
    <Editor
      style="height: 500px; overflow-y: hidden"
      v-model="html"
      :defaultConfig="editorConfig"
      :mode="mode"
      :value="value"
      @onCreated="onCreated"
    />
  </div>
</template>
<script>
import Vue from 'vue'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'

export default Vue.extend({
  components: { Editor, Toolbar },
  props: {
    value: String
  },
  data() {
    return {
      editor: null,
      html: '',
      toolbarConfig: {
        // 仅仅想排除掉某些菜单，其他都保留
        excludeKeys: [
          // 禁用视频
          'group-video'
        ]
      },
      editorConfig: {
        placeholder: '请输入内容...',
        MENU_CONF: {
          uploadImage: {
            uploadImgShowBase64: true,

            // customUpload: this.update,
            base64LimitSize: 1024 * 1024 //1mb
          }
          //
        }
      },
      mode: 'default' // or 'simple'
    }
  },
  watch: {
    value: {
      handler(newData) {
        if (!newData) return
        let that = this
        that.$nextTick(() => {
          that.html = newData
        })
      },
      immediate: true
    }
  },
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    }
  },
  mounted() {
    // 模拟 ajax 请求，异步渲染编辑器
    // setTimeout(() => {
    //   this.html = '<p>模拟 Ajax 异步设置内容 HTML</p>'
    // }, 1500)
  },
  beforeCreate() {
    //     const editor = this.editor
    //     editor.config.uploadImgShowBase64 = true // 转64方法,富文本中存入的是base64
    //     editor.config.onchange = (newHtml) => {
    //       this.editorData = newHtml
    //       this.$store.state.richtext = this.editorData
    //     }
    //     // 创建编辑器
    // const editor = this.editor
    // editor.create()
  },

  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  }
})
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
